export default __webpack_public_path__ + "static/media/flag-trinidad-and-tobago.d8b1a3e2.svg";